export default __webpack_public_path__ + "static/life_at_03-e2a84439de6ee3983f0a522fe7cbf8f9.jpg";